// extracted by mini-css-extract-plugin
export default {"wrapper":"e_CwxkMp","mobile":"mobile","_isPhoneSpec":"mfgJ8dLY","success":"U6jarcF5"};